import { forwardRef, useState } from "react";
import { Alert, Autocomplete, Box, Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, Slide, TextField, Typography } from "@mui/material";
import DropDownLoading from "../frames/dropdown_loading";
import { getIdList, newUser } from "./user_halper";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function NewUser({ onClose, open }) {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [userIDList, setUserIDList] = useState([]);

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setAlertMessage(null);
        setUserIDList([]);
        onClose();
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSourceChange = (event) => {
        setIsLoading(true);
        getIdList(event.target.value).then((res) => {
            setUserIDList(res);
            setIsLoading(false);
        }).catch((err) => {
            console.error(err);
            setIsLoading(false);
        });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isLoading) return;
        const data = new FormData(event.currentTarget);
        const source = data.get("source");
        const username = data.get("username");
        const ref_id = data.get("ref");
        const pass = "crm123";
        var flag = true;
        if (__error_handler(username.length > 3, "username", "Incorrect username.")) {
            flag = false;
        }
        if (flag) {
            const _json = { "source": source, "username": username, "ref_id": ref_id, "pass": pass };
            setIsLoading(true);
            newUser(_json).then((res) => {
                setAlertMessage({ "severity": "success", "message": "New user created." })
                setIsLoading(false);
            }).catch((err) => {
                setAlertMessage({ "severity": "error", "message": err.message })
                setIsLoading(false);
            });
        }
    }

    const validateInputs = () => {
        return true;
    }

    return (

        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} >
            <DialogTitle variant="h5" color="info">New User</DialogTitle>
            <DialogContent>
                {alertMessage === null ? "" :
                    <Box sx={{ mt: 2, mb: 2 }}>
                        <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                    </Box>
                }
                <Grid size={{ xs: 12, sm: 12 }} component="form" onSubmit={handleSubmit} noValidate>
                    <Grid container spacing={2} sx={{ p: 2 }}>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel id="source-label">Source</InputLabel>
                                <Select
                                    labelId="source-label"
                                    id="source"
                                    label="Source"
                                    name="source"
                                    defaultValue={""}
                                    fullWidth
                                    error={inputErrors.name}
                                    helperText={inputErrors.name}
                                    onChange={handleSourceChange}
                                >
                                    <MenuItem value={"C"}>Client</MenuItem>
                                    <MenuItem value={"E"}>Employee</MenuItem>
                                    <MenuItem value={"V"}>Vendor</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="username" fullWidth error={inputErrors.username} type="text" helperText={inputErrors.username} placeholder="Username use for login" label="Username" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <Autocomplete
                                disablePortal
                                noOptionsText={<DropDownLoading title="Loading IDs ..." />}
                                options={userIDList === null ? [] : userIDList}
                                getOptionLabel={(option) => String(option.ac_ref)}
                                renderOption={(props, option) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                        <Box key={key} component="li" {...optionProps} >
                                            <Typography variant="body2">{option.name} <Typography variant="caption" color="info">({option.id}) #{option.ac_ref}</Typography></Typography>
                                        </Box>
                                    );
                                }}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="ref" fullWidth error={inputErrors.ref} type="text" helperText={inputErrors.ref} autoFocus placeholder="User ID" label="User ID" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Typography variant="caption" color="warning">Default password is <b>crm123</b>.</Typography>
                            {isLoading ? <LinearProgress color="secondary" /> : ""}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default NewUser;
